import React from 'react';
import { ClinicInfoPanel } from '../info/clinicInfoParts';

const HoursText = ({ hours }) => {
    return (
        <ClinicInfoPanel title="Weekly Schedule" icon="bi-calendar-week">
            <div className="clinic-settings-hours-list">
                {hours.map((h, idx) => (
                    <div key={idx} className="clinic-settings-hours-item">
                        <div className="clinic-settings-hours-item__day">{h.day}</div>
                        <div className="clinic-settings-hours-item__time">
                            {h.status ? `${h.start} – ${h.end}` : 'Closed'}
                        </div>
                        <span className={`clinic-settings-status-pill ${h.status ? 'is-open' : 'is-closed'}`}>
                            <i className={`bi ${h.status ? 'bi-door-open' : 'bi-door-closed'}`}></i>
                            {h.status ? 'Open' : 'Closed'}
                        </span>
                        {h.note && (
                            <div className="clinic-settings-hours-item__note">
                                <i className="bi bi-chat-left-text me-1"></i>
                                {h.note}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </ClinicInfoPanel>
    );
};

export default HoursText;
